import React, { useEffect, useState } from "react"
import { Link, useParams } from 'react-router-dom'
import Slider from "react-slick"
import { addToCart, buyListing, getListingByID, getListingsByUserId, removeFromCart } from "../../firebase/listings"
import DialogConfirmation from "../../components/dialogs/DialogConfirmation"
import { getUserData } from "../../firebase/users"
import { getCategoryById } from "../../firebase/categories"
import { toast } from "react-toastify"
import { useAtom } from "jotai"
import { cartListAtom, recipientIdAtom, showIndividualMessageBoxAtom, userAtom } from "../../store"
import { brands } from "../../utils/data"
import Breadcrumb from "../../components/Breadcrumb"
import DialogOffer from "../../components/dialogs/DialogOffer"
import { createCart } from "../../firebase/carts"
import { useAuth } from "../../context/authContext"

const MarketplaceItemDetails = () => {
  const [openDelivery, setOpenDelivery] = useState(false)
  const [openPayments, setOpenPayments] = useState(false)
  const [cartList, setCartList] = useAtom(cartListAtom)
  const { cardId } = useParams()
  const [card, setCard] = useState(null)
  const [loading, setLoading] = useState(true)
  const [seller, setSeller] = useState(null)
  const [categoryName, setCategoryName] = useState(null)
  const [userData, setUserData] = useAtom(userAtom)
  const [activeImage, setActiveImage] = useState(null)
  const [showOfferModal, setShowOfferModal] = useState(false)
  const [recipientId, setRecipientId] = useAtom(recipientIdAtom)
  const [showSuccessCartModal, setShowSuccessCartModal] = useState(false)
  const [showIndividualMessageBox, setShowIndividualMessageBox] = useAtom(showIndividualMessageBoxAtom)
  const [activeAddToCart, setActiveAddToCart] = useState(true)
  const { getUpdatedUserData } = useAuth()

  const verticalThumbSliderSettings = {
    dots: true,
    infinite: false,
    vertical: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    verticalSwiping: true
  }

  const thumbSliderSettings = {
    dots: true,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
  }

  useEffect(() => {
    getListingByID(cardId).then((item) => {
      setCard(item)
      setActiveImage(item.pictures[0])
    })

    scrollTo({
      top: 0
    })
  }, [cardId])

  useEffect(() => {
    if (card && card.seller) {
      getUserData(card.seller).then((item) => {
        setSeller(item)
        setLoading(false)
      })

      getCategoryById(card.category).then((item) => {
        setCategoryName(item.name)
      })

      getCategoryById(card.category).then((item) => {
        setCategoryName(item.name)
      })
    }
  }, [card])

  useEffect(() => {
    if (card) {
      setActiveAddToCart(!listingIsInCart())
    }
  }, [cartList])

  const listingIsInCart = () => {
    if (cartList.findIndex(item => item.id === card.id)) return true
    return false
  }

  const formatDate = (date) => {
    const options = { hour: 'numeric', minute: 'numeric', hour12: true }
    const timeString = date.toLocaleTimeString('en-US', options)
    const dateString = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`

    return `${timeString} ${dateString}`
  }

  const setMessageToSeller = () => {
    setShowIndividualMessageBox(true)
    setRecipientId(card.seller)
  }

  const handleCreateCart = () => {
    setCartList([...cartList, { ...card, count: 1 }])
  }

  const handleAddToCart = async () => {
    // Guard against adding a duplicate, not against adding at all: this read
    // the other way round, so the only item it would ever add was one the
    // cart already held.
    if (!listingIsInCart()) {
      handleCreateCart()
      setShowSuccessCartModal(true)
    }
  }

  const handleMakeOffer = () => {
    setShowOfferModal(true)
  }

  return (
    <div className="flex w-full h-[100vh]">
      <div className="p-14 max-w-[1440px] w-full m-auto">
        <DialogConfirmation
          open={loading}
          onClose={() => { }}
          type="loading"
          title="Please wait"
          message="We are processing your booking request. Please wait and don’t close this page"
          buttonText="Cancel"
          onButtonClick={() => setOpenDialog(null)}
        />
        <DialogConfirmation
          message="Your listing has been successfully added to cart!"
          open={showSuccessCartModal}
          onClose={() => setShowSuccessCartModal(false)}
          buttonText="Done"
          title="Listing Carted"
          iconSrc="/assets/icons/icon-check-circle.svg"
          type="confirm"
        />

        {
          card &&
          <DialogOffer
            open={showOfferModal}
            card={card}
            onClose={() => { setShowOfferModal(false) }}
          />
        }

        <Breadcrumb link="/listing" />

        {
          !loading && seller ?
            <div className="flex flex-col lg:flex-row items-start gap-6 lg:gap-12">
              <div className="w-full grid grid-cols-1 lg:grid-cols-5 gap-5">
                {/* Thumbnail Slider */}
                {/* <Slider {...verticalThumbSliderSettings} arrows={false} className="col-span-1 max-lg:!hidden"> */}
                <div className="flex flex-col gap-y-4 max-lg:!hidden">
                  {card.pictures.slice(0, 5).map((image) => (
                    <div key={`thumb-${image}`} className="px-[2px] h-[20%] lg:px-1">
                      <div
                        className={`relative cursor-pointe h-full w-full ${activeImage === image
                          ? "!opacity-100 !border-primary"
                          : "opacity-40"
                          }`}
                        onClick={() => setActiveImage(image)}
                      >
                        <img
                          src={image}
                          className="absolute top-0 left-0 w-full object-cover h-full border-primary border-[1px]"
                          alt={`Thumbnail ${image}`}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                {/* </Slider> */}

                {/* Main Displayed Image */}
                <div className="product-ask-section w-full pt-[100%] lg:col-span-4">
                  <img
                    src={activeImage}
                    className="absolute top-0 w-full h-full object-cover border-primary border-[1px]"
                    alt="Main Displayed"
                  />
                </div>

                {/* <Slider {...thumbSliderSettings} arrows={false} className='lg:!hidden space-10'> */}
                <div className="grid grid-cols-5  sm:gap-x-4 gap-x-1 !w-full lg:!hidden">
                  {card.pictures.map((image) => (
                    <div key={`thumb-${image}`} className="px-[2px] lg:px-1">
                      <div
                        className={`relative cursor-pointe w-full pt-[100%] ${activeImage === image
                          ? "!opacity-100 !border-primary"
                          : "opacity-40"
                          }`}
                        onClick={() => setActiveImage(image)}
                      >
                        <img
                          src={image}
                          className="absolute top-0 left-0 w-full object-cover h-full border-primary border-[1px]"
                          alt={`Thumbnail ${image}`}
                        />
                      </div>
                    </div>
                  ))}
                </div>
                {/* </Slider> */}
              </div>

              <div className="w-full px-4 py-5 border-[#434343] border-[1px]">
                <h1 className="uppercase text-white font-bold leading-[1.2] text-[20px] lg:text-[20px]">
                  {card.title}
                </h1>

                <hr className="my-4 border-gray"></hr>

                <div className="w-full md:flex items-center justify-between mt-2 lg:mt-0">
                  <div>
                    <div className="flex items-center text-primary text-[20px] lg:text-[20px] font-aeonik font-bold">
                      ${card.price.toFixed(2)}
                      <span className="text-white font-thin text-sm ml-3">Listing Price</span>
                    </div>

                    {
                      card.original_price &&
                      <div className="flex items-center text-[#454545] text-[20px] lg:text-[20px] font-aeonik font-bold">
                        ${card.original_price.toFixed(2)}
                        <span className="text-white font-thin text-sm ml-3">Seller Cost</span>
                      </div>
                    }
                  </div>

                  <hr className="my-4 border-gray md:hidden"></hr>

                  {
                    userData.id !== seller.id &&
                    <div className="flex">
                      <div
                        className="mr-2 uppercase text-sm bg-[#1C1C1C] px-8 py-3 text-[#474747]"
                      >
                        Make Offer
                      </div>

                      <div
                        className="mr-2 uppercase text-sm bg-[#404040] px-8 py-3 text-[#666]"
                      >
                        Add to Cart
                      </div>
                    </div>
                  }
                </div>

                <hr className="my-4 border-gray"></hr>

                <span className="uppercase text-primary text-[12px]">Description:</span>

                <p className="text-white text-sm font-thin mt-4 lg:mt-0">
                  {card.description}

                  {
                    card.seller !== userData.id ?

                      <div className="w-full border border-[#FFFFFF]/20 p-3 lg:p-5 mt-8">
                        <div className="w-full flex items-center justify-between pb-3 border-b border-b-[#fff]/20">
                          <span className="font-aero uppercase text-base lg:text-xl text-white">
                            Seller
                          </span>
                          <div className="flex items-center space-x-2">
                            <div className="flex items-center">
                              {Array.from({ length: 5 }).map((_, index) => (
                                <img
                                  key={index}
                                  src="/assets/icons/icon-star-fill.svg"
                                  className={`w-[14px] lg:w-[24px] ${index < seller.ratings ? "" : "opacity-30"}`}
                                  alt="star"
                                />
                              ))}
                            </div>
                            <span className="text-xs lg:text-sm text-white block">
                              {seller.ratings.toFixed(1)}
                            </span>
                          </div>
                        </div>

                        <div className="pt-5 flex items-center justify-between">

                          <div className="flex items-center space-x-2 lg:space-x-4">
                            <div className="w-12 h-12 flex justify-center items-center">
                              <img src="/assets/avatars/default.png" className="w-full h-full" alt="seller" />
                            </div>

                            <div className="flex flex-col items-start">
                              <span className="text-sm lg:text-base text-white">
                                {seller.displayName}
                              </span>

                              <Link className="text-[10px] lg:text-xs flex items-center text-primary underline" to={`/user-profile/${card.seller}`}>
                                View Profile
                              </Link>
                            </div>
                          </div>
                          <div
                            className="flex border-[1px] border-primary text-sm px-8 py-3 text-primary transition-all opacity-50 border-style-decoration"
                          >
                            <img src="/assets/icons/icon-message-primary.svg" alt='message' className="mr-1" />

                            Send Message
                          </div>
                        </div>
                      </div>
                      :
                      <hr className="my-4 border-gray"></hr>
                  }

                  <div className={`w-full space-y-4 ${card.seller !== userData.id ? 'mt-8' : ''}`}>
                    <div className="w-full flex">
                      <span className="uppercase text-xs font-bold text-primary w-full max-w-[140px] lg:max-w-[210px] block">
                        Release Year:
                      </span>
                      <span>{card.released_year}</span>
                    </div>
                    <div className="w-full flex">
                      <span className="uppercase text-xs font-bold text-primary w-full max-w-[140px] lg:max-w-[210px] block">
                        Condition:
                      </span>
                      <span>{card.condition}</span>
                    </div>
                    <div className="w-full flex">
                      <span className="uppercase text-xs font-bold text-primary w-full max-w-[140px] lg:max-w-[210px] block">
                        Sub Category:
                      </span>
                      <span>{card.sub_category}</span>
                    </div>
                    <div className="w-full flex">
                      <span className="uppercase text-xs font-bold text-primary w-full max-w-[140px] lg:max-w-[210px] block">
                        Rarity:
                      </span>
                      <span>{card.rarity}</span>
                    </div>
                    <div className="w-full flex">
                      <span className="uppercase text-xs font-bold text-primary w-full max-w-[140px] lg:max-w-[210px] block">
                        Date Posted:
                      </span>
                      <span>{formatDate(new Date(card.created_at.seconds * 1000))}</span>
                    </div>
                  </div>
                </p>
              </div>
            </div>
            : ""
        }
      </div >
    </div>
  )
}

export default MarketplaceItemDetails
